module.exports = __webpack_public_path__ + "static/img/Sample Document - Document your emergency.55ba6b12.svg";